/*
 Sohel 03/16/2023 2789721057 Integrated Save API
Rohini 03/16/2023 2789721057 design enhancements done in the screens.
 Sohel 03/16/2023 2789721057 remove Form and To
 Dilip 03/17/2023 2789721057 added validations
  suresh peddavoora 03/23/2023 2789721057 textfield alignments fixes
Ravi 06/26/2023 2789721057 fixed submit issue
  */
import React, {useContext, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import * as Yup from 'yup';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useSelector, useDispatch} from 'react-redux';
import {
  fetchTransitionData,
  postTranslationFieldData,
  resetMainTranslation,
} from '../../../redux/reducers/TranslationTable';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const AddValueForm = ({handleLookupClose, rowEditData, isEditMode, rowData, MainValues}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {successMessage, errorMessage, addTranslationFieldStatus, translationData} = useSelector(
    ({translationTableData}) => translationTableData,
  );
  const dispatch = useDispatch();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const checkTranslationCodeExist = (value) => {
    const data = rowEditData?.inputValue ?
      translationData?.filter(
        (el) =>
          el?.inputValue?.toUpperCase()?.trim() !== rowEditData?.inputValue?.toUpperCase()?.trim(),
      ) :
      translationData;
    if (data?.length > 0 && value) {
      const titleData = [];
      data?.forEach((i) => {
        if (i?.inputValue.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    code:
      // isEditMode && rowEditData?.inputValue
      //   ? null
      //   :
      Yup.mixed()
        .test('code', 'Input Value is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        })
        .test('code', 'Input Value already exist', (value) => !checkTranslationCodeExist(value)),
    value:
      isEditMode && rowEditData?.outputValue ?
        null :
        Yup.mixed().test('value', 'Output Value is required', (value) => {
          if (!value) {
            return false;
          } else {
            return true;
          }
        }),
  });
  useEffect(() => {
    if (addTranslationFieldStatus === 200 && successMessage) {
      setTimeout(() => {
        dispatch(resetMainTranslation());
        handleLookupClose();
      }, 2500);
      dispatch(fetchTransitionData(MainValues?.code));
      // dispatch(fetchTranslationFieldData(MainValues?.code))
    }
  }, [addTranslationFieldStatus, successMessage]);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        dispatch(resetMainTranslation());
      }, 2500);
    }
  }, [errorMessage]);
  const initialValues = {
    code: isEditMode && rowEditData?.inputValue ? rowEditData?.inputValue : '',
    value: isEditMode && rowEditData?.outputValue ? rowEditData?.outputValue : '',
  };
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      inputValue: values?.code ? values?.code : '',
      outputValue: values?.value ? values?.value : '',
      tableCode: MainValues?.code ? MainValues?.code : '',
      translationValuesId: rowEditData?.translationValuesId ? rowEditData?.translationValuesId : 0,
    };
    dispatch(postTranslationFieldData(payload));
  };
  return (
    <div className={classes.addRule}>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              setFieldValue,
              touched,
              errors,
              resetForm,
              handleBlur,
            } = props;
            return (
              <>
                <div>
                  <Form autoComplete="off" noValidate>
                    <div className="form-row global-field-textfields new-standard-textfields">
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Input Value`}
                          label={`Input Value`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="code"
                          required
                          value={values?.code}
                          onChange={(e) => {
                            setFieldValue('code', e.target.value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors?.code && errors.code}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-6 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Output Value`}
                          label={`Output Value`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="value"
                          required
                          value={values?.value}
                          onChange={(e) => {
                            setFieldValue('value', e.target.value);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.value}
                          error={Boolean(touched.value && errors.value)}
                        />
                        <FormHelperText>
                          {touched.value && errors?.value && errors.value}
                        </FormHelperText>
                      </div>
                      <div className="col-md-12 d-flex justify-content-center">
                        <Button
                          variant="outlined"
                          onClick={() => {
                            resetForm(initialValues);
                          }}
                          className={`mx-1 reset-btn ${classes.buttonRoot}`}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          disabled={enabledSubmission}
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddValueForm;
